export enum ExtraEntry {
    Clabe = 1,
    Rfc = 2,
}
